import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ServingPageBase} from '../../general/ServingPageBase';
import {AppStatus} from '../../../@models/app-status';
import {animate, style, transition, trigger} from '@angular/animations';
import {ServingStatus} from '../../../../shared-gen/Machine/Status/ServingStatus';
import {OrderItem} from '../../../../shared-gen/Model/Orders/OrderItem';
import {MenuFun} from '../../../../shared/model/menus/menu.fun';
import {AppService} from '../../../services/app.service';
import {decodeEscapeCodesToHtml} from "../../../../shared/utils/text-escape-codes";

@Component({
	selector: 'app-tur-serving',
	templateUrl: './tur-serving.component.html',
	styleUrls: ['./tur-serving.component.scss'],
	animations: [
		trigger('fadeInOut', [
			transition(':enter', [   // :enter is alias to 'void => *'
				style({opacity:0}),
				animate(300, style({opacity:1}))
			])
		])
	]
})
export class TurServingComponent extends ServingPageBase implements OnInit, OnDestroy {

	@ViewChild("videoElement", {static: false}) videoElement: ElementRef;

	servingStatus: ServingStatus = emptyServingStatus();
	bringBackItemStep: 'NotRequested' | 'Requested' | 'BroughtBack' = 'NotRequested';

	cart: OrderItem[];
	count: number = 0;

	servingVideoSrc: string;

	constructor(app: AppService) {
		super(app);
		this.servingVideoSrc = app.http.serverUrl + "/device/video/serving";
	}

	onStatusChanged(status: AppStatus) {
		super.onStatusChanged(status);

		const order = status.deviceStatus.VendingStatus.Order;
		if(order && order.Items) {
			this.cart = order.Items;
		}
		else {
			this.cart = [];
		}
		this.countOrder();

		const servingStatus = status.deviceStatus.MachineStatus.ServingStatus;
		if (servingStatus && servingStatus.State)
			this.servingStatus = servingStatus;
		else
			this.servingStatus = emptyServingStatus();

		if (this.servingStatus.State === 'Processing')
			this.bringBackItemStep = 'NotRequested';

		this.toggleVideo()
	}

	private toggleVideo() {
		return;
		if(!this.videoElement) {
			return;
		}
		if(this.servingStatus.State !== 'Holding' && this.servingStatus.State !== 'Removable') {
			this.videoElement.nativeElement.play();
		}
		else {
			this.videoElement.nativeElement.pause();
		}
	}

	async bringBucketUp() {
		this.bringBackItemStep = 'Requested';
		const timeUntilLiftBackMs = 10000; // Tried out with SandenVendoVM
		window.setTimeout(() => this.bringBackItemStep = 'BroughtBack', timeUntilLiftBackMs);
		await this.app.api.machineApi.bringBack();
	}

	getImage(item: OrderItem) {
		if (item) {
			const base = MenuFun.findProductBase(this.menu, item.Product);
			return this.app.api.dataApi.getImageUrl(base.Image);
		}
	}

	countOrder() {
		this.count = 0;
		if (this.cart)
			this.count = this.cart.length;
	}

	textToHtml(text: string) {
		return decodeEscapeCodesToHtml(text);
	}
}

function emptyServingStatus() {
	return { State: 'Processing', CurrentItemIndex: 0, ItemsCount: 0 } as ServingStatus;
}
